<div class="d-flex flex-column" [style.gap.rem]="2">
  <div class="d-flex flex-column gap-1">
    <div class="header" i18n>Set Password</div>
    <div class="subtext" i18n>
      A verification code has been sent to the email address below. If that’s not the correct email address, you’ll have
      to go back and set a new one.
    </div>
  </div>

  <div class="d-flex flex-column w-100 gap-4" *ngIf="formGroup$ | async as formGroup" [formGroup]="formGroup">
    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'email'" i18n>Email</label>
      <app-email-input
        formControlName="email"
        controlId="email"
        [error]="formSubmitted && formGroup.controls.email.invalid" />
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.email.invalid"
        [errors]="formGroup.controls.email.errors"
        [customErrorMessages]="customErrorMessages.email" />
    </div>

    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'code'" i18n>Code</label>
      <app-text-input
        #codeInput
        formControlName="code"
        controlId="code"
        [error]="formSubmitted && formGroup.controls.code.invalid" />
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.code.invalid"
        [errors]="formGroup.controls.code.errors"
        [customErrorMessages]="customErrorMessages.code" />
    </div>

    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'newPassword'" i18n>New Password</label>
      <app-password-input
        formControlName="newPassword"
        controlId="newPassword"
        [error]="formSubmitted && formGroup.controls.newPassword.invalid" />
      <div i18n class="subtext">
        Must contain 8+ characters, including 1 number, 1 special character, 1 uppercase letter, and 1 lowercase letter
      </div>
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.newPassword.invalid"
        [errors]="formGroup.controls.newPassword.errors"
        [customErrorMessages]="customErrorMessages.newPassword" />
    </div>

    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'confirmPassword'" i18n>Confirm Password</label>
      <app-password-input
        formControlName="confirmPassword"
        controlId="confirmPassword"
        [error]="formSubmitted && formGroup.controls.confirmPassword.invalid" />
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.confirmPassword.invalid"
        [errors]="formGroup.controls.confirmPassword.errors"
        [customErrorMessages]="customErrorMessages.confirmPassword" />
    </div>
  </div>

  <app-button class="w-100" i18n [type]="ButtonTypeEnum.primary" (buttonClick)="resetPassword()">
    Set New Password
  </app-button>
</div>
